import AvgOfFacingsByBrandChart from "./AvgOfFacingsByBrandChart";
export default AvgOfFacingsByBrandChart;
